import ItemTable from "./item-table";

export default ItemTable;